import { render, staticRenderFns } from "./MemberCredential.vue?vue&type=template&id=8285d530&scoped=true"
import script from "./MemberCredential.vue?vue&type=script&lang=js"
export * from "./MemberCredential.vue?vue&type=script&lang=js"
import style0 from "./MemberCredential.vue?vue&type=style&index=0&id=8285d530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8285d530",
  null
  
)

export default component.exports